import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import red from '@material-ui/core/colors/red'
import indigo from '@material-ui/core/colors/indigo'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { ENDED_ACTION } from "../../../constants";
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'

const stylesForGameResultBox = theme => ({
  gameResultBox: {
  },
})

export const GameResultBox = withStyles(stylesForGameResultBox, { withTheme: true })((props) => {
  const { classes, gameResult } = props
  var player1Result, player2Result
  switch (gameResult.action) {
    case ENDED_ACTION.FIVE:
      player1Result = gameResult.user.userName === gameResult.player1.userName ? 'win' : 'lose'
      player2Result = gameResult.user.userName === gameResult.player2.userName ? 'win' : 'lose'
      break
    case ENDED_ACTION.RESIGN:
      player1Result = gameResult.user.userName === gameResult.player1.userName ? 'lose' : 'win'
      player2Result = gameResult.user.userName === gameResult.player2.userName ? 'lose' : 'win'
      break
    case ENDED_ACTION.OFFER_DRAW:
      player1Result = 'draw'
      player2Result = 'draw'
      break
    case ENDED_ACTION.TIMEOUT:
      player1Result = gameResult.user.userName === gameResult.player1.userName ? 'lose' : 'win'
      player2Result = gameResult.user.userName === gameResult.player2.userName ? 'lose' : 'win'
      break
    default:
      break
  }
  return (
    <div className={classes.gameResultBox}>
      <Grid container>
        <Grid item xs={6}>
          <GameResultPlayerBox player={gameResult.player1} result={player1Result}/>
        </Grid>
        <Grid item xs={6}>
          <GameResultPlayerBox player={gameResult.player2} result={player2Result}/>
        </Grid>
      </Grid>
    </div>
  )
})

const stylesForGameResultPlayerBox = theme => ({
  gameResultPlayerBox: {
    textAlign: 'center',
    color: theme.palette.grey[700]
  },
  avatarBox: {
    margin: `0 auto ${theme.spacing.unit}px auto`,
    width: theme.spacing.unit * 5,
    height: theme.spacing.unit * 5,
  },
  win: {
    marginTop: theme.spacing.unit,
    color: red[700],
    fontWeight: 900,
  },
  lose: {
    marginTop: theme.spacing.unit,
    color: indigo[700],
    fontWeight: 900,
  },
  draw: {
    marginTop: theme.spacing.unit,
    color: theme.palette.grey[500],
    fontWeight: 900,
  },
})

const GameResultPlayerBox = withStyles(stylesForGameResultPlayerBox, { withTheme: true })((props) => {
  const { classes, player, result } = props
  var resultStr
  if (result === 'win') resultStr = (<Typography variant='title' className={classes.win}>WIN</Typography>);
  if (result === 'lose') resultStr = (<Typography variant='title' className={classes.lose}>LOSE</Typography>);
  if (result === 'draw') resultStr = (<Typography variant='title' className={classes.draw}>DRAW</Typography>);

  return (
    <div className={classes.gameResultPlayerBox}>
      <div className={classes.avatarBox}>
        <CustomAvatar
          name={player.displayName}
          alt={player.displayName}
          src={player.avatarPhotoURL}
          className={classes.avatar}
        />
      </div>
      <Typography color='inherit' noWrap>{`${player.userName}`}</Typography>
      {resultStr}
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/Pages/Game/components/CommonComponents.js